// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSecondaryProgramDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryProgramDTO from '../models/SecondaryProgramDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
    academicYear: number | null | null;
    secondaryProgramId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
            academicYear: null,
            secondaryProgramId: null,
        },
        initValues);
    },
    id: 'id',
    academicYear: 'academicYear',
    secondaryProgramId: 'secondaryProgramId',
}

interface Result extends ResultDTO {
    secondaryProgram: SecondaryProgramDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryProgram: null,
        },
        initValues);
    },
    secondaryProgram: 'secondaryProgram',
}

export { Request, Result };